import React, { useContext } from 'react';
import { cs } from '@bbkAdminUtils/css-utils';
import {
  PlayContext,
  PlayObjectProperty,
} from '@bbkAdminComponents/play/play-context';
import { TippyTooltip } from '@bbkAdminComponents/tooltips/tippy-tooltip';
import icons from '@bbkAdminUtils/icons';
import { FeatureFlagsE, useFeatureFlags } from '@bbkAdminUtils/feature-flags';
import { OfferNodeType } from '@bbkAdminComponents/play/play-offer-node-select';

export const AddControlButton: React.FC = () => {
  const { getPlayObjectProperty, setPlayObjectProperty } =
    useContext(PlayContext);

  const isTestNode =
    getPlayObjectProperty(PlayObjectProperty.OFFER_NODE_TYPE) ===
    OfferNodeType.TEST;

  return (
    isTestNode && (
      <>
        <button
          className={cs(
            'tw-ml-4 tw-mr-2 tw-cursor-pointer tw-text-sm tw-font-bold tw-text-cbrprimary-600'
          )}
          onClick={() => {
            setPlayObjectProperty(PlayObjectProperty.CONTROL_PERCENTAGE, 5);
            if (getPlayObjectProperty(PlayObjectProperty.OFFER_PERCENTAGE)) {
              setPlayObjectProperty(PlayObjectProperty.OFFER_PERCENTAGE, 95);
            }
          }}
        >
          Add control <span className="tw-font-light">(optional)</span>
        </button>

        <TippyTooltip
          content="Maintain a baseline to track changes in your play performance over time."
          tippyOptions={{
            placement: 'right',
          }}
        >
          <span className="info-icon tw-font-light tw-text-cbrprimary-600">
            {icons.cbrInfo}
          </span>
        </TippyTooltip>
      </>
    )
  );
};
